<div class="choose-account">
    <!-- Login option box -->
    <div class="white-box choose-ac mt-4">
            <div class="error-list" v-if="errorsMessage">
                    <ul class="error-msg">
                      <li v-for="(error,x) in errorsMessage" :key="x">
                        <div v-for="(err,i) in error" :key="i">
                          <p> {{err}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
        <div class="row align-items-center">
            <div class="col-lg-8">
                <div class="table-title pb-0">
                    <h5>Choose an account</h5>

                </div>
            </div>
            <!-- <div class="col-lg-4">
                <a href="#" class="text-muted">Sign out</a>
            </div> -->
        </div>
        <hr>
        <div class="account-list">
            <div class="account-list-item" v-for="(account, index) in AccountList" :key="index" @click.prevent="selectedAccount(account)">
                <!-- <p>{{account}}</p> -->
                <!-- <p>{{account.logo_path}}</p> -->
                <a href="#"></a>
                <div class="img-wrap">
                    <img :src="account.logo_path" alt="">
                </div>
                <div class="account-name">
                    <p>{{account.company_name}}</p>
                    <span>{{account.company_email}}</span>
                </div>
            </div>
            <!-- <div class="account-list-item">
                <a href="#"></a>
                <div class="img-wrap">
                    <img src="https://dummyimage.com/70x70/eee/333&text=DP" alt="">
                </div>
                <div class="account-name">
                    <p>Sangam Uprety</p>
                    <span>user01@gmail.com</span>
                </div>
            </div> -->
        </div>
    </div>
</div>